module.exports = __webpack_public_path__ + "e1fba2fa74863ad554002f9cae87e930.png";